module.exports = __webpack_public_path__ + "static/gallery6-8e547f7b495c32101dcfd075561587e6.jpg";